export const DOCUMENTS_SCREEN = {
    documents: 'Documents',
} as const;

export const DOCUMENTS_SCREEN_NAMES: string[] = Object.values(DOCUMENTS_SCREEN);
